import { render } from "./Pdf.vue?vue&type=template&id=0d793234&scoped=true"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"

import "./Pdf.vue?vue&type=style&index=0&id=0d793234&scoped=true&lang=css"

import exportComponent from "/Users/nakarinjaiseengam/Photofair-STM-POS/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d793234"]])

export default __exports__